import * as React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

const useStyles = makeStyles({
formGroup: {
  columnGap: "3px",
  marginRight: "5px"
},
controlLabel: {
  fontSize: "10px",
  },
label: {
  fontSize: "10px",
  height: "auto"
},
radio:{
  padding: "0 2px 0 0",
  fontSize: "5px"
}
})

export default function RadioOptions(props) {

    const {label, value, options, loading, onChange, disabled} = props;
    const classes = useStyles()

  return (
    <FormControl>
      {label && <FormLabel id="radio-label">{label}</FormLabel>}
      <RadioGroup
        row
        value={value}
        name="radio"
        classes={{root: classes.formGroup}}
      >
        {Array.isArray(options) && options.map((o)=><FormControlLabel key={`radio-${o[Object.keys(o)[0]].toString()}`} classes={{root: classes.root, label: classes.controlLabel}} 
        value={o[Object.keys(o)[0]].toString()} 
        control={<Radio disabled={disabled} classes={{root: classes.radio}} onClick={disabled? null : (e)=> onChange(e)} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: 14, color:"#3B5158" }}/>} icon={<RadioButtonUncheckedIcon style={{ fontSize: 14 }} />}/>} 
        label={o[Object.keys(o)[1]]} 
        disabled={loading}/>)}
      </RadioGroup>
    </FormControl>
  );
}
